import React from 'react';
import useMain from '../../../hooks/useMain';
import { numberWithCommas, titleCase } from '../../../utils/helpers';
import Image from '../../common/image';
import { FlippingDebit } from '../ingredients/cards';

const PlannerDashboard = () => {
	const { userData, theme } = useMain();
	const {
		name,
		totalAmount,
		cardsAmount,
		mmiAmount,
		dailyBinaryLimit,
		sellLimit,
		withdrawLimit,
		limit,
		mlm,
		sponsor,
	} = userData.currentCard;
	const totalUsedMaxCap = userData.MMIUsedMaxCap + userData.totalCardsUsedMaxCap;

	return (
		<div className='card myCards'>
			<div className='card-body'>
				{userData.class === 'planner' ? (
					<>
						<div className='row gy-4 my-4 text-center'>
							<div className='col-md-4 offset-md-4 col-12 text-center'>
								<FlippingDebit
									card={userData.currentCard.name}
									text={userData.bemchain.uid}
								/>
							</div>
						</div>
						<div className='row gy-4 my-4'>
							<div className='offset-md-3 col-md-3 col-12'>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Card Name:{' '}
									<span className={`text-set4-${theme}`}>{titleCase(name)}</span>
								</div>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Total Amount:{' '}
									<span className={`text-set4-${theme}`}>
										${numberWithCommas(totalAmount / 1e6)}
									</span>
								</div>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Card Packages Amount:{' '}
									<span className={`text-set4-${theme}`}>
										${numberWithCommas(cardsAmount / 1e6)}
									</span>
								</div>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Card MMI Amount:{' '}
									<span className={`text-set4-${theme}`}>
										${numberWithCommas(mmiAmount / 1e6)}
									</span>
								</div>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Total Max Cap:{' '}
									<span className={`text-set4-${theme}`}>
										${numberWithCommas(userData.maxCap / 1e6)}
									</span>
								</div>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Total Used Max Cap:{' '}
									<span className={`text-set4-${theme}`}>
										${numberWithCommas(parseInt(totalUsedMaxCap / 1e6))}
									</span>
								</div>
							</div>
							<div className='col-md-3 col-12'>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Daily Binary Limit:{' '}
									<span className={`text-set4-${theme}`}>
										${numberWithCommas(dailyBinaryLimit / 1e6)}
									</span>
								</div>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Internal Exchange Limit:{' '}
									<span className={`text-set4-${theme}`}>
										${numberWithCommas(sellLimit / 1e6)}
									</span>
								</div>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Withdraw Limit:{' '}
									<span className={`text-set4-${theme}`}>
										${numberWithCommas(withdrawLimit / 1e6)}
									</span>
								</div>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Transfer Limit:{' '}
									<span className={`text-set4-${theme}`}>
										${numberWithCommas(limit / 1e6)}
									</span>
								</div>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ MLM:{' '}
									<span className={`text-set4-${theme}`}>{mlm} Levels</span>
								</div>
								<div className={`my-2 fs-5 text-set3-${theme}`}>
									✅ Sponsor Percentage:{' '}
									<span className={`text-set4-${theme}`}>{sponsor}%</span>
								</div>
							</div>
						</div>
					</>
				) : (
					<div className='row my-5'>
						<div className='col text-center'>
							<Image
								fileName='icons/warn.svg'
								height='100px'
								className='mb-3'
							/>
							<h4>
								Upgrade your Investor cards to planner card or purchase one to
								activate Planner Dashboard.
							</h4>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default PlannerDashboard;
